
/* FODBOLDGAVER — QUICK ADD V4 */
(function () {
  "use strict";

  function init() {
    if (window.FGQuickAddInitialized) return;

    const modal = document.getElementById("QuickAddModal");
    if (!modal) return;

    const overlay = modal.querySelector(".QuickAddOverlay");
    const closeButton = modal.querySelector(".QuickAddClose");
    const title = modal.querySelector(".QuickAddTitle");
    const price = modal.querySelector(".QuickAddPrice");
    const variants = modal.querySelector(".QuickAddVariants");
    const imageList = modal.querySelector(".QuickAddImageList");
    const submit = modal.querySelector(".QuickAddSubmit");

    if (
      !overlay || !closeButton || !title || !price ||
      !variants || !imageList || !submit
    ) return;

    window.FGQuickAddInitialized = true;

    let selectedVariant = null;
    let inventory = {};
    let busy = false;
    let requestId = 0;
    let lastTrigger = null;
    let previousOverflow = "";
    let previousPaddingRight = "";
    let successTimer = null;

    const root = () => window.Shopify?.routes?.root || "/";

    const money = cents =>
      new Intl.NumberFormat("da-DK", {
        style: "currency",
        currency: "DKK"
      }).format(Number(cents) / 100);

    const isOpen = () => modal.classList.contains("is-open");

    // Ensure the modal is outside grid/section stacking contexts.
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    modal.classList.add("hidden");
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");

    function getStockNotice() {
      let notice = modal.querySelector(".QuickAddStock");

      if (!notice) {
        notice = document.createElement("div");
        notice.className = "QuickAddStock";
        notice.setAttribute("role", "status");
        price.insertAdjacentElement("afterend", notice);
      }

      return notice;
    }

    function getErrorNotice() {
      let notice = modal.querySelector(".QuickAddError");

      if (!notice) {
        notice = document.createElement("div");
        notice.className = "QuickAddError";
        notice.setAttribute("role", "alert");
        submit.insertAdjacentElement("beforebegin", notice);
      }

      return notice;
    }

    function showError(message) {
      const notice = getErrorNotice();
      notice.textContent = message;
      notice.hidden = false;
    }

    function clearError() {
      const notice = getErrorNotice();
      notice.textContent = "";
      notice.hidden = true;
    }

    function openModal(trigger) {
      clearTimeout(successTimer);

      lastTrigger = trigger;
      previousOverflow = document.body.style.overflow;
      previousPaddingRight = document.body.style.paddingRight;

      const scrollbarWidth =
        window.innerWidth - document.documentElement.clientWidth;

      if (scrollbarWidth > 0) {
        document.body.style.paddingRight =
          scrollbarWidth + "px";
      }

      document.body.style.overflow = "hidden";

      modal.classList.remove("hidden");
      modal.classList.add("is-open");
      modal.setAttribute("aria-hidden", "false");

      closeButton.focus({ preventScroll: true });
    }

    function closeModal() {
      if (!isOpen() || busy) return;

      requestId++;
      clearTimeout(successTimer);

      modal.classList.remove("is-open");
      modal.classList.add("hidden");
      modal.setAttribute("aria-hidden", "true");

      document.body.style.overflow = previousOverflow;
      document.body.style.paddingRight = previousPaddingRight;

      selectedVariant = null;

      if (lastTrigger?.isConnected) {
        lastTrigger.focus({ preventScroll: true });
      }
    }

    function updateStock() {
      const notice = getStockNotice();

      notice.textContent = "";
      notice.hidden = true;

      if (!selectedVariant) return;

      const quantity = inventory[String(selectedVariant.id)];

      if (
        selectedVariant.available &&
        Number.isInteger(Number(quantity)) &&
        Number(quantity) > 0 &&
        Number(quantity) < 5
      ) {
        notice.textContent =
          "Kun " + quantity + " tilbage på lager";
        notice.hidden = false;
      }
    }

    function updateSelection() {
      variants.querySelectorAll(
        ".QuickAddVariantButton"
      ).forEach(button => {
        const active =
          String(selectedVariant?.id) === button.dataset.variantId;

        button.classList.toggle("is-active", active);
        button.setAttribute("aria-pressed", String(active));
      });

      if (selectedVariant) {
        price.textContent = money(selectedVariant.price);
      }

      submit.disabled = !selectedVariant?.available || busy;
      submit.textContent = "Tilføj til kurv";

      updateStock();
      clearError();
    }

    function renderVariants(product) {
      variants.replaceChildren();
      selectedVariant = null;

      const available = (product.variants || []).filter(
        variant => variant.available
      );

      if (!available.length) {
        variants.textContent = "Produktet er udsolgt.";
        submit.disabled = true;
        return;
      }

      selectedVariant = available[0];

      const fragment = document.createDocumentFragment();

      available.forEach(variant => {
        const button = document.createElement("button");

        button.type = "button";
        button.className = "QuickAddVariantButton";
        button.dataset.variantId = String(variant.id);

        const label = variant.public_title ||
          variant.title ||
          "Standard";

        button.textContent = label;
        button.setAttribute("aria-pressed", "false");

        button.addEventListener("click", () => {
          if (busy) return;

          selectedVariant = variant;
          updateSelection();
        });

        fragment.appendChild(button);
      });

      variants.appendChild(fragment);
      updateSelection();
    }

    
function renderImages(product) {
  imageList.replaceChildren();

  const sources = (product.images || [])
    .map(image =>
      typeof image === "string" ? image : image?.src
    )
    .filter(Boolean);

  if (!sources.length && product.featured_image) {
    const featured = product.featured_image;
    sources.push(
      typeof featured === "string" ? featured : featured.src
    );
  }

  if (!sources.length) return;

  const gallery = document.createElement("div");
  gallery.className = "FGQuickGalleryV5";

  const viewport = document.createElement("div");
  viewport.className = "FGQuickGalleryV5__viewport";
  viewport.setAttribute("aria-label", "Produktbilleder");
  viewport.setAttribute("tabindex", "0");

  const track = document.createElement("div");
  track.className = "FGQuickGalleryV5__track";

  const slides = [];
  const thumbs = [];
  const dots = [];

  let activeIndex = 0;
  let scrollFrame = 0;

  function imageUrl(source, width) {
    try {
      const url = new URL(source, window.location.origin);
      url.searchParams.set("width", String(width));
      return url.toString();
    } catch {
      return source;
    }
  }

  sources.forEach((source, index) => {
    const slide = document.createElement("div");
    slide.className = "FGQuickGalleryV5__slide";

    const image = document.createElement("img");
    image.src = imageUrl(source, 900);
    image.alt = `${product.title} – billede ${index + 1}`;
    image.loading = index === 0 ? "eager" : "lazy";
    image.decoding = "async";
    image.draggable = false;

    slide.appendChild(image);
    track.appendChild(slide);
    slides.push(slide);
  });

  viewport.appendChild(track);
  gallery.appendChild(viewport);

  function setActive(index) {
    activeIndex = Math.max(
      0,
      Math.min(index, slides.length - 1)
    );

    thumbs.forEach((button, i) => {
      const active = i === activeIndex;
      button.classList.toggle("is-active", active);
      button.setAttribute("aria-pressed", String(active));
    });

    dots.forEach((button, i) => {
      const active = i === activeIndex;
      button.classList.toggle("is-active", active);
      button.setAttribute("aria-current", String(active));
    });

    if (previousButton) {
      previousButton.disabled = activeIndex === 0;
    }

    if (nextButton) {
      nextButton.disabled = activeIndex === slides.length - 1;
    }
  }

  function goTo(index, smooth = true) {
    const target = Math.max(
      0,
      Math.min(index, slides.length - 1)
    );

    setActive(target);

    viewport.scrollTo({
      left: slides[target].offsetLeft - track.offsetLeft,
      behavior: smooth ? "smooth" : "instant"
    });
  }

  let previousButton = null;
  let nextButton = null;

  if (sources.length > 1) {
    const navigation = document.createElement("div");
    navigation.className = "FGQuickGalleryV5__navigation";

    previousButton = document.createElement("button");
    previousButton.type = "button";
    previousButton.className = "FGQuickGalleryV5__arrow";
    previousButton.setAttribute(
      "aria-label",
      "Forrige produktbillede"
    );
    previousButton.textContent = "‹";

    nextButton = document.createElement("button");
    nextButton.type = "button";
    nextButton.className = "FGQuickGalleryV5__arrow";
    nextButton.setAttribute(
      "aria-label",
      "Næste produktbillede"
    );
    nextButton.textContent = "›";

    previousButton.addEventListener("click", () => {
      goTo(activeIndex - 1);
    });

    nextButton.addEventListener("click", () => {
      goTo(activeIndex + 1);
    });

    navigation.append(previousButton, nextButton);
    gallery.appendChild(navigation);

    const thumbsWrap = document.createElement("div");
    thumbsWrap.className = "FGQuickGalleryV5__thumbs";

    sources.forEach((source, index) => {
      const button = document.createElement("button");
      button.type = "button";
      button.className = "FGQuickGalleryV5__thumb";
      button.setAttribute(
        "aria-label",
        `Vis produktbillede ${index + 1}`
      );

      const image = document.createElement("img");
      image.src = imageUrl(source, 140);
      image.alt = "";
      image.loading = "lazy";

      button.appendChild(image);
      button.addEventListener("click", () => goTo(index));

      thumbs.push(button);
      thumbsWrap.appendChild(button);
    });

    gallery.appendChild(thumbsWrap);

    const dotsWrap = document.createElement("div");
    dotsWrap.className = "FGQuickGalleryV5__dots";

    sources.forEach((_, index) => {
      const dot = document.createElement("button");
      dot.type = "button";
      dot.className = "FGQuickGalleryV5__dot";
      dot.setAttribute(
        "aria-label",
        `Vis produktbillede ${index + 1}`
      );

      dot.addEventListener("click", () => goTo(index));

      dots.push(dot);
      dotsWrap.appendChild(dot);
    });

    gallery.appendChild(dotsWrap);

    viewport.addEventListener("scroll", () => {
      cancelAnimationFrame(scrollFrame);

      scrollFrame = requestAnimationFrame(() => {
        if (!viewport.clientWidth) return;

        const index = Math.round(
          viewport.scrollLeft / viewport.clientWidth
        );

        setActive(index);
      });
    }, { passive: true });

    viewport.addEventListener("keydown", event => {
      if (event.key === "ArrowRight") {
        event.preventDefault();
        goTo(activeIndex + 1);
      }

      if (event.key === "ArrowLeft") {
        event.preventDefault();
        goTo(activeIndex - 1);
      }
    });
  }

  imageList.appendChild(gallery);
  setActive(0);
}


    async function addToCart(variantId) {
      if (!variantId || !Number.isFinite(Number(variantId))) {
        throw new Error("Ugyldig produktvariant.");
      }

      const response = await fetch(root() + "cart/add.js", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: 1
        })
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(
          result.description ||
          result.message ||
          "Produktet kunne ikke tilføjes."
        );
      }

      
/* Behold vores eksisterende Quick Add-event */
document.dispatchEvent(
  new CustomEvent("fg:cart:added", {
    detail: { item: result }
  })
);

/* Lad Prestige opdatere og åbne den native drawer */
document.dispatchEvent(
  new CustomEvent("product:added", {
    bubbles: true,
    detail: {
      quantity: result.quantity || 1
    }
  })
);


      return result;
    }

    async function handleQuickAdd(event) {
      const trigger = event.target.closest(".QuickAddButton");

      if (!trigger || !document.contains(trigger)) return;

      event.preventDefault();
      event.stopPropagation();

      if (busy || isOpen()) return;

      const hasVariants =
        trigger.dataset.hasVariants === "true";

      if (!hasVariants) {
        busy = true;
        trigger.disabled = true;

        try {
          await addToCart(trigger.dataset.variantId);

          trigger.classList.add("is-added");

          setTimeout(() => {
            trigger.classList.remove("is-added");
          }, 1200);
        } catch (error) {
          window.alert(
            error.message || "Kunne ikke tilføje produktet."
          );
        } finally {
          busy = false;
          trigger.disabled = false;
        }

        return;
      }

      try {
        inventory = JSON.parse(
          trigger.dataset.variantInventory || "{}"
        );
      } catch {
        inventory = {};
      }

      const currentRequest = ++requestId;

      selectedVariant = null;
      title.textContent = "Indlæser produkt...";
      price.textContent = "";
      variants.replaceChildren();
      imageList.replaceChildren();

      getStockNotice().hidden = true;
      clearError();

      submit.disabled = true;
      submit.textContent = "Indlæser...";

      openModal(trigger);

      try {
        const handle = trigger.dataset.productHandle;

        if (!handle) {
          throw new Error("Produktet kunne ikke findes.");
        }

        const response = await fetch(
          root() +
          "products/" +
          encodeURIComponent(handle) +
          ".js",
          { credentials: "same-origin" }
        );

        if (!response.ok) {
          throw new Error("Produktet kunne ikke indlæses.");
        }

        const product = await response.json();

        if (currentRequest !== requestId || !isOpen()) {
          return;
        }

        title.textContent = product.title;
        price.textContent = money(product.price);

        renderImages(product);
        renderVariants(product);
      } catch (error) {
        if (currentRequest !== requestId || !isOpen()) {
          return;
        }

        title.textContent = "Der opstod en fejl";
        showError(error.message || "Prøv igen om lidt.");
        submit.disabled = true;
        submit.textContent = "Ikke tilgængelig";
      }
    }

    document.addEventListener(
      "click",
      handleQuickAdd,
      true
    );

    closeButton.addEventListener("click", closeModal);
    overlay.addEventListener("click", closeModal);

    document.addEventListener("keydown", event => {
      if (!isOpen()) return;

      if (event.key === "Escape") {
        event.preventDefault();
        closeModal();
        return;
      }

      if (event.key !== "Tab") return;

      const focusable = Array.from(
        modal.querySelectorAll(
          'button:not([disabled]), a[href], input:not([disabled])'
        )
      ).filter(element => element.getClientRects().length);

      if (!focusable.length) {
        event.preventDefault();
        closeButton.focus();
        return;
      }

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (
        event.shiftKey &&
        (document.activeElement === first ||
          !modal.contains(document.activeElement))
      ) {
        event.preventDefault();
        last.focus();
      } else if (
        !event.shiftKey &&
        (document.activeElement === last ||
          !modal.contains(document.activeElement))
      ) {
        event.preventDefault();
        first.focus();
      }
    });

    submit.addEventListener("click", async event => {
      event.preventDefault();

      if (
        busy ||
        !selectedVariant ||
        !selectedVariant.available
      ) return;

      busy = true;
      submit.disabled = true;
      submit.textContent = "Tilføjer...";
      clearError();

      try {
        await addToCart(selectedVariant.id);

        submit.textContent = "Tilføjet ✓";

        busy = false;

        successTimer = setTimeout(() => {
          closeModal();
        }, 500);
      } catch (error) {
        busy = false;
        submit.disabled = false;
        submit.textContent = "Prøv igen";
        showError(
          error.message || "Produktet kunne ikke tilføjes."
        );
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
